import React from "react";
import "../../Styles/yellowcalf.css/Transaction_Receipt.css";

function Transaction_Receipt() {
  return (
    <div className="transaction-container" style={{ paddingTop: "25px" }}>
      <div className="transaction-row">
        <div className="transaction-col-md-12">
          <div className="transaction-panel transaction-panel-white">
            <div className="transaction-panel-body">
              <div className="transaction-customer-index">
                <h3 className="transaction-main-panel-title">
                  Transaction Receipt
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="transaction-receipt-row">
        <div className="transaction-receipt-col-md-12">
          <div className="transaction-receipt-panel transaction-receipt-panel-white">
            <div
              className="transaction-receipt-panel-heading"
              style={{ display: "block", minHeight: "35px" }}
            >
              <div className="transaction-receipt-panel-tools"></div>
              <div id="status-alert"></div>
            </div>

            <div className="transaction-receipt-panel-body">
              <div className="transaction-receipt-payment-view">
                <div className="transaction-receipt-pd">
                  <div>
                    <table className="transaction-receipt-tablestyle transaction-receipt-fullwidth">
                      <tbody>
                        <tr>
                          <td
                            colSpan="3"
                            className="transaction-receipt-tdstyle transaction-receipt-pa1"
                          >
                           
                            <div className="transaction-receipt-pull-right">
                              <strong>Transaction Receipt</strong>
                            </div>
                          </td>
                          <td
                            colSpan="3"
                            className="transaction-receipt-tdstyle transaction-receipt-paid"
                          >
                            <table className="transaction-receipt-tablestyle transaction-receipt-smpl">
                              <tbody>
                                <tr>
                                  <th className="transaction-receipt-thstyle transaction-receipt-test1">
                                    Date &amp; Time
                                  </th>
                                  <td className="transaction-receipt-tdstyle transaction-receipt-test1">
                                    Wed Sep 25 2024 10:50:54 AM
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <th className="transaction-receipt-thstyle">
                            School Name
                          </th>
                          <td
                            className="transaction-receipt-tdstyle"
                            colSpan="4"
                          >
                            Demo school for development
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="transaction-receipt-wallettdleft"
                            colSpan="2"
                          >
                            <strong>Student</strong> : Mayank - Admission02
                          </td>
                          <td colSpan="2">
                            <strong>Grade</strong> : 7(A)
                          </td>
                          <td
                            className="transaction-receipt-wallettdright"
                            colSpan="2"
                          >
                            <strong>Division</strong> : A
                          </td>
                        </tr>

                        <tr>
                          <th className="transaction-receipt-thstyle">
                            CATEGORY
                          </th>
                          <th className="transaction-receipt-thstyle">ITEM</th>
                          <th className="transaction-receipt-thstyle">QTY</th>
                          <th className="transaction-receipt-thstyle">PRICE</th>
                          <th className="transaction-receipt-thstyle">TOTAL</th>
                        </tr>

                        <tr>
                          <td
                            className="transaction-receipt-tdstyle"
                            colSpan="5"
                          >
                            No receipt found for the transaction.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="transaction-receipt-cs">
                  <button
                    id="w0"
                    className="transaction-receipt-btn transaction-receipt-btn-primary transaction-receipt-btn-lg"
                  >
                    Print
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transaction_Receipt;
